import React, { useCallback, useEffect } from 'react'
import styled from 'styled-components'
import Colors from '../../../assets/styles/Colors'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AuthState } from '../../../store/authSlice'
import {
  WelcomerState,
  setHeaderPassedCount,
  setHeaderTotalCount,
  setUpdateWelcomerProgress,
  setWelcomerVisibleStep,
} from '../../../store/welcomerSlice'

const WelcomerProgressbar: React.FC<{
  style?: React.CSSProperties
  stepName?: string
}> = ({ style, stepName = '' }) => {
  //
  const dispatch = useAppDispatch()
  //
  const navigate = useNavigate()
  //
  const Pathname = window.location.pathname
  //
  const { progress, filter, checkout, screenHeader } = useAppSelector(
    (data: { welcomer: WelcomerState }) => data.welcomer,
  )
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  const isUserLoggedIn = !!(auth.user?.userType === 'User' && auth.user?.phone && auth.user?.email)
  //
  //
  //
  const updateProgressBarCallback = useCallback(() => {
    //
    const comparePage = progress.find((p) => p.id === 6) // URL: /welcomer-offers
    //
    const forOtherPage = progress.find((p) => p.id === 10) // URL: /welcomer-for-other
    //
    const forMeOtherPage = progress.find((p) => p.id === 12) //URL: /welcomer-for-me-and-other
    //
    const insurerPage = progress.find((p) => p.id === 11) // URL: /welcomer-insurer
    //
    const policyRegistrationPage = progress.find((p) => p.id === 14) // URL: /welcomer-policy-registration
    //
    if (isUserLoggedIn && policyRegistrationPage && policyRegistrationPage.isVisible === true) {
      dispatch(setWelcomerVisibleStep({ id: 14, isVisible: false }))
    } else if (!isUserLoggedIn && policyRegistrationPage && policyRegistrationPage.isVisible === false) {
      dispatch(setWelcomerVisibleStep({ id: 14, isVisible: true }))
    }
    //
    //
    if (Pathname && progress && progress.find((p) => p.url === Pathname)) {
      const current = progress.find((p) => p.url === Pathname)
      //
      // update progress status
      if (current && current.id && current.active === false) {
        dispatch(
          setUpdateWelcomerProgress({
            id: current.id,
            title: stepName ?? '',
          }),
        )
      }
      //
      //
      // show & hide welcomer offers screen
      if (filter.chooseMethod === 'my-choose' && comparePage && comparePage.isVisible === false) {
        // show step
        dispatch(
          setWelcomerVisibleStep({
            id: 6,
            isVisible: true,
          }),
        )
        //
      } else if (filter.chooseMethod === 'frani-choose' && comparePage && comparePage.isVisible === true) {
        // hide step
        dispatch(
          setWelcomerVisibleStep({
            id: 6,
            isVisible: false,
          }),
        )
      }
      //
      //
      // show welcomer for me and other screen
      if (checkout.forWho === 'me-and-other' && forMeOtherPage && forMeOtherPage.isVisible === false) {
        return [
          dispatch(
            // show for me and other
            setWelcomerVisibleStep({
              id: 12,
              isVisible: true,
            }),
          ),
          // hide for me page
          dispatch(
            setWelcomerVisibleStep({
              id: 9,
              isVisible: false,
            }),
          ),
        ]
      } else if (checkout.forWho === 'for-me' && forMeOtherPage && forMeOtherPage.isVisible === true) {
        return [
          dispatch(
            // hide for me and other page
            setWelcomerVisibleStep({
              id: 12,
              isVisible: false,
            }),
          ),
          // show for me page
          dispatch(
            setWelcomerVisibleStep({
              id: 9,
              isVisible: true,
            }),
          ),
        ]
      } else if (checkout.forWho === 'for-other' && forMeOtherPage && forMeOtherPage.isVisible === true) {
        return [
          dispatch(
            // hide for me and other page
            setWelcomerVisibleStep({
              id: 12,
              isVisible: false,
            }),
          ),
          // show for other page
          dispatch(
            setWelcomerVisibleStep({
              id: 10,
              isVisible: true,
            }),
          ),
        ]
      }
      // show welcomer forOther screen
      if (checkout.forWho === 'for-other' && forOtherPage && forOtherPage.isVisible === false) {
        return [
          dispatch(
            // show for other page
            setWelcomerVisibleStep({
              id: 10,
              isVisible: true,
            }),
          ),
          // hide for me page
          dispatch(
            setWelcomerVisibleStep({
              id: 9,
              isVisible: false,
            }),
          ),
        ]
        // hide welcomer forOther screen
      } else if (checkout.forWho === 'for-me' && forOtherPage && forOtherPage.isVisible === true) {
        return [
          //  hide for other page
          dispatch(
            setWelcomerVisibleStep({
              id: 10,
              isVisible: false,
            }),
          ),
          // show for me page
          dispatch(
            setWelcomerVisibleStep({
              id: 9,
              isVisible: true,
            }),
          ),
        ]
        // hide welcomer forOther screen
      } else if (checkout.forWho === 'me-and-other' && forOtherPage && forOtherPage.isVisible === true) {
        // hide for other page
        return [
          dispatch(
            setWelcomerVisibleStep({
              id: 10,
              isVisible: false,
            }),
          ),
          dispatch(
            setWelcomerVisibleStep({
              id: 11,
              isVisible: false,
            }),
          ),
          // show for me and other page
          dispatch(
            setWelcomerVisibleStep({
              id: 12,
              isVisible: true,
            }),
          ),
        ]
      }
      //
      //
      // show welcomer insurer screen
      if (checkout.forWho === 'for-other' && insurerPage && insurerPage.isVisible === false) {
        dispatch(
          setWelcomerVisibleStep({
            id: 11,
            isVisible: true,
          }),
        )
        // hide welcomer insurer screen
      } else if (checkout.forWho === 'for-me' && insurerPage && insurerPage.isVisible === true) {
        dispatch(
          setWelcomerVisibleStep({
            id: 11,
            isVisible: false,
          }),
        )
      }
      //
    }
  }, [Pathname, progress, stepName, filter, checkout.forWho, isUserLoggedIn, dispatch])
  //
  useEffect(() => {
    updateProgressBarCallback()

    return () => {
      // Cleanup logic if needed
    }
  }, [updateProgressBarCallback]) // Check if this dependency is causing the issue

  //
  //
  const visibledSteps = progress?.filter((x) => x.isVisible === true)
  //
  //
  // update progress counts
  const updateProgressCountCallBack = useCallback(() => {
    //
    const passedStepCount = visibledSteps?.filter((x) => x.passed === true)?.length
    //
    // update progress total count
    if (visibledSteps && screenHeader.totalCount !== visibledSteps.length) {
      dispatch(setHeaderTotalCount(visibledSteps.length))
    }
    //
    // update current page count
    if (passedStepCount && screenHeader.passedCount !== passedStepCount) {
      dispatch(setHeaderPassedCount(passedStepCount))
    }

    //
  }, [dispatch, visibledSteps, screenHeader.totalCount, screenHeader.passedCount])
  //
  // update progress counts
  useEffect(() => {
    updateProgressCountCallBack()

    return () => {}
  }, [updateProgressCountCallBack])
  //

  return (
    <Wrapper style={style}>
      <Content>
        {visibledSteps?.map((item, index) => (
          <Block key={index} $active={item.active} $passed={item.passed}>
            <Ball
              onClick={() => navigate(item.url)}
              style={{
                pointerEvents: item.passed ? 'unset' : 'none',
              }}
            >
              {item.title ? (
                <HoverText>
                  <span>{item.title}</span> <Triangle />
                </HoverText>
              ) : null}
            </Ball>
            <Line />
          </Block>
        ))}
      </Content>
    </Wrapper>
  )
}

//
const Triangle = styled.div`
  width: 0px;
  height: 0px;
  border-width: 9px 8px 8px;
  border-style: solid;
  border-color: ${Colors.white} transparent transparent;
  border-image: initial;
  position: absolute;
  top: -16px;
  transform: rotate(180deg);
`
//
const HoverText = styled.div`
  user-select: none;
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  white-space: nowrap;
  height: 40px;
  border-radius: 4px;
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  padding-inline: 30px;
  display: none;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: ${Colors.nevadaGrey};
  z-index: 5;
`
const Line = styled.div`
  height: 2px;
  width: 20px;
  background-color: ${Colors.secondaryGrey};
  user-select: none;
  pointer-events: none;
`
const Ball = styled.div`
  position: relative;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background-color: ${Colors.white};
  box-shadow: inset 0px 0px 0px 2px ${Colors.primaryRed};
  cursor: pointer;
`
const Block = styled.div<{ $active: boolean; $passed: boolean }>`
  display: flex;
  align-items: center;

  /* ball */
  ${Ball} {
    height: ${({ $active }) => ($active ? '16px' : `8px`)};
    width: ${({ $active }) => ($active ? '16px' : `8px`)};

    box-shadow: ${({ $passed, $active }) =>
      $passed || $active
        ? `inset 0px 0px 0px 2px ${Colors.primaryRed}`
        : `inset 0px 0px 0px 2px ${Colors.secondaryGrey}`};

    &:hover {
      height: 16px;
      width: 16px;
      margin-inline: ${({ $active }) => ($active ? '-0px' : `-4px`)};
      /*  */
      ${HoverText} {
        display: flex;
      }
    }
  }

  /* line */
  ${Line} {
    background-color: ${({ $active, $passed }) =>
      $active ? Colors.secondaryGrey : $passed ? Colors.primaryRed : Colors.secondaryGrey};
  }
`

const Wrapper = styled.div`
  /*  */
`
const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${Block} {
    &:last-child {
      ${Line} {
        display: none;
      }
    }
  }
`
//
export default WelcomerProgressbar
